export default __webpack_public_path__ + "static/media/triangles-no-7.a3f1c683.mid";